// components/FloatingLoader.tsx
import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import styles from './index.module.css';

const FloatingLoader = () => {
  return (
    <div className={styles.overlay}>
      <CircularProgress />
    </div>
  );
};

export default FloatingLoader;
